import { callApi } from '@local_modules/generic/fetch'

export async function loadAllSyncs (accountingOrganisationId) {
  let apiUrl = '/api/data-sync/list-all'

  if (accountingOrganisationId) {
    apiUrl += `?accountingOrganisationId=${accountingOrganisationId}`
  }

  const data = await callApi(apiUrl)
  // console.log('api data', data)

  return data
}
